import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import "firebase/compat/storage";
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0LnXTYetZU7BGlIuMW6r5K3NsGx6qXe8",
  authDomain: "inettech-website.firebaseapp.com",
  projectId: "inettech-website",
  storageBucket: "inettech-website.appspot.com",
  messagingSenderId: "872278590472",
  appId: "1:872278590472:web:f20e7517b08ded1bbdfdbd",
  measurementId: "G-VYLBREZNQJ"
};
// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const analytics = firebase.analytics();
const storage = firebase.storage();

// Export storage so it can be used in other files
export { storage, analytics };